var React = require('react');

function PlaylistMusicInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M31.25 12.5H6.25V16.6667H31.25V12.5ZM31.25 20.8333H6.25V25H31.25V20.8333ZM6.25 33.3333H22.9167V29.1667H6.25V33.3333ZM35.4167 12.5V29.5417C34.7708 29.3125 34.0625 29.1667 33.3333 29.1667C29.875 29.1667 27.0833 31.9583 27.0833 35.4167C27.0833 38.875 29.875 41.6667 33.3333 41.6667C36.7917 41.6667 39.5833 38.875 39.5833 35.4167V16.6667H45.8333V12.5H35.4167Z","fill":"#FFFDFB"}));
}

PlaylistMusicInline.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50","fill":"none"};

module.exports = PlaylistMusicInline;

PlaylistMusicInline.default = PlaylistMusicInline;
